// INFOAFP Luxury Theme JS
document.addEventListener('DOMContentLoaded', function() {
  console.log('INFOAFP Luxury Theme initialized.');

  // Mobile menu toggle
  const mobileToggle = document.querySelector('.mobile-nav-toggle');
  const desktopNav = document.querySelector('.desktop-nav');

  if (mobileToggle && desktopNav) {
    mobileToggle.addEventListener('click', function() {
      const isVisible = desktopNav.style.display === 'flex';
      desktopNav.style.display = isVisible ? 'none' : 'flex';
      desktopNav.style.flexDirection = 'column';
      desktopNav.style.position = 'absolute';
      desktopNav.style.top = '100%';
      desktopNav.style.left = '0';
      desktopNav.style.right = '0';
      desktopNav.style.background = '#FFFFFF';
      desktopNav.style.padding = '20px';
      desktopNav.style.boxShadow = '0 10px 25px rgba(0,0,0,0.1)';
    });
  }
});
